import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'CERCA TRA GLI ESERCIZI SPECIALI ZANICHELLI',
        description: "Trovi gli esercizi Zanichelli pensati per le prove comuni e per le prove d'ingresso.",
        name: 'SpecialExercisesSearchForm',
        tutorialName: 'crea-verifica_tab-speciali-Zanichelli'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'right',
        xPlacement: 'RIGHT',
        yPlacement: 'MIDDLE',
        xOffset: -5,
        yOffset: 3
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'bottom',
        xPlacement: 'LEFT',
        yPlacement: 'MIDDLE',
        xOffset: 10,
        yOffset: 3
    }
};
